import { render, staticRenderFns } from "./ShouliChart.vue?vue&type=template&id=212a9901&scoped=true"
import script from "./ShouliChart.vue?vue&type=script&lang=js"
export * from "./ShouliChart.vue?vue&type=script&lang=js"
import style0 from "./ShouliChart.vue?vue&type=style&index=0&id=212a9901&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212a9901",
  null
  
)

export default component.exports